import './AboutHero.css';
import checkIcon from '../../assets/check.png';

function AboutHero() {
  return (
    <section className="hero about-hero">
      <div className="about-grid">
        <div className="about-text">
          <h1>Hi, I'm Loubna.</h1>
          <h2 className="about-subheading">Software Engineer & Author.</h2>
          <p>
            I'm a software engineer interested in optimization, machine learning, and AI. 
            I'm currently exploring PhD opportunities and enjoy research that makes systems smarter.
            <br /><br />
            On the side, I wrote 
            <a href="/before-we-get-older"> <em>Before We Get Older</em></a>, 
            a small book shaped by life lessons from my teenage years. I later published my second book, 
            <a href="/the-in-between"> <em>The In-Between</em></a>, which explores healing, balance, and how to live in the in-between.
            <br /><br />
            I also share what I learn — from tech to books — in short articles on 
            <a href="https://medium.com/@Loubna-DS" target="_blank" rel="noopener noreferrer"> Medium</a>.
          </p>
          <p className="small-links">
            You can find me on 
            <a href="https://www.linkedin.com/in/loubna-bouzenzen-86a6441b8/" target="_blank" rel="noopener noreferrer"> LinkedIn</a> and 
            <a href="https://www.instagram.com/elbylit?igsh=MWM1aXFscXdxejNwcA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer"> Instagram</a>.
          </p>
        </div>
        <div className="about-highlights">
          <ul>
            <li>
              <img src={checkIcon} alt="check" className="check-icon" />
              <span>Software Engineer</span>
            </li>
            <li>
              <img src={checkIcon} alt="check" className="check-icon" />
              <span>Author & Writer</span>
            </li>
            <li>
              <img src={checkIcon} alt="check" className="check-icon" />
              <span>Interested in AI, Optimization & Research</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default AboutHero;